/* INCÓGNITA — Soul layer behaviors v2
 * - Entrance curtain
 * - Cursor reticle w/ label
 * - Scroll-progress HUD
 * - Decode-scramble text effect
 * - Inject kinetic ticker + hero HUD + hero statement (if missing)
 */
(function () {
  'use strict';

  const prefersReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasFinePointer =
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------- entrance curtain cleanup --------------------------- */
  // The curtain is injected inline in <body> via document.write so it covers
  // the page before first paint. Here we just remove it once the CSS
  // animation finishes, to free the layer.
  function cleanupCurtain() {
    const curtain = document.querySelector('.inc-curtain-stage');
    if (!curtain) return;
    const done = () => {
      curtain.remove();
      document.documentElement.classList.remove('inc-curtain-armed');
    };
    curtain.addEventListener('animationend', (e) => {
      if (e.animationName === 'inc-curtain-out') done();
    });
    // Failsafe
    setTimeout(done, 2500);
  }


  /* ---------------- scroll-progress HUD (top-right) --------------------- */
  function buildHUD() {
    const hud = document.createElement('div');
    hud.className = 'inc-hud';
    hud.setAttribute('aria-hidden', 'true');
    hud.innerHTML = `
      <span class="inc-hud__k">IDX</span>
      <span class="inc-hud__v">000</span>
      <span class="inc-hud__bar"></span>
    `;
    document.body.appendChild(hud);
    const v = hud.querySelector('.inc-hud__v');
    const bar = hud.querySelector('.inc-hud__bar');

    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
      v.textContent = String(Math.round(pct)).padStart(3, '0');
      bar.style.setProperty('--scroll-pct', pct + '%');
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------------- decode/scramble effect ------------------------------ */
  const SCRAMBLE_CHARS = '!<>-_\\/[]{}—=+*^?#_0123456789';

  function scramble(el, finalText, duration = 900) {
    if (prefersReducedMotion) { el.textContent = finalText; return; }
    const start = performance.now();
    const len = finalText.length;
    function frame(now) {
      const t = Math.min(1, (now - start) / duration);
      let out = '';
      for (let i = 0; i < len; i++) {
        const reveal = t > (i / len) * 0.85;
        out += reveal
          ? finalText[i]
          : SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
      }
      el.textContent = out;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function wireScramble() {
    const targets = document.querySelectorAll('.inc-scramble');
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              scramble(e.target, e.target.getAttribute('data-text') || e.target.textContent.trim());
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.3 })
      : null;
    targets.forEach((t) => {
      const finalText = t.getAttribute('data-text') || t.textContent.trim();
      t.setAttribute('data-text', finalText);
      if (io) io.observe(t);
      else scramble(t, finalText);
    });
  }



  /* ---------------- restructure footer --------------------------------- */
  function restructureFooter() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    const copyright = footer.querySelector('.footer__copyright');
    const bottomWrapper = copyright && copyright.parentElement;
    if (!copyright || !bottomWrapper) return;

    // Move Trocas & Devoluções (link list) into the bottom row
    const trocasBlock = footer.querySelector('.footer__list-links');
    if (trocasBlock && !bottomWrapper.contains(trocasBlock)) {
      bottomWrapper.insertBefore(trocasBlock, copyright);
    }

    // Move social icons (Instagram) into the bottom row
    const socialList = footer.querySelector('.footer__list-social');
    if (socialList && !bottomWrapper.contains(socialList)) {
      bottomWrapper.appendChild(socialList);
    }

    // Unwrap the shop-name link so "Incógnita" is plain text (no hyperlink)
    const copyContent = copyright.querySelector('.copyright__content');
    if (copyContent) {
      const origin = window.location.origin;
      copyContent.querySelectorAll('a.link, a').forEach((a) => {
        const href = a.getAttribute('href') || '';
        if (href === '/' || href === origin || href === origin + '/') {
          a.replaceWith(document.createTextNode(a.textContent));
        }
      });
    }

    footer.classList.add('footer--restructured');
  }

  /* ---------------- bootstrap ------------------------------------------ */
  function init() {
    cleanupCurtain();
    buildHUD();
    wireScramble();
    restructureFooter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
